import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@fortawesome/fontawesome-free/css/all.min.css";
import $ajax from "@/api/base";
import buttonGroup from "@/components/btn-group";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap";
// import "bootstrap/scss/bootstrap.scss";
import "element-ui/lib/theme-chalk/index.css";
import "@/common/base.less";
import tUpload from "@/components/upload.vue";
import locale from 'element-ui/lib/locale/lang/en'
import * as echarts from "echarts";
import tTable from "@/components/table/tTable";
import tTableColumn from "@/components/tTableColumn";
import select from "@/components/select/select";

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;

import ElementUI from "element-ui";
Vue.use(ElementUI, {locale});
Vue.component(tUpload.name, tUpload);
Vue.component(select.name, select);
Vue.component(tTable.name, tTable);
Vue.component(tTableColumn.name, tTableColumn);
Vue.component("button-group", buttonGroup);

Vue.prototype.$ajax = $ajax;
Vue.prototype.$ = window.$;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
